import { render } from "./displayScreenDemo.vue?vue&type=template&id=8707f9c4&scoped=true"
import script from "./displayScreenDemo.vue?vue&type=script&lang=js"
export * from "./displayScreenDemo.vue?vue&type=script&lang=js"

import "./displayScreenDemo.vue?vue&type=style&index=0&id=8707f9c4&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8707f9c4"]])

export default __exports__